module.exports = __webpack_public_path__ + "assets/img/play_sound.efbad458.gif";